import { useLocation, useMatches } from 'react-router-dom'
import type { Crumb, RouteHandle } from '@/lib/routeHandles.types'

export function isRouteHandle(value: unknown): value is RouteHandle {
  if (typeof value !== 'object' || value === null) return false

  return 'crumb' in value || 'fullBleed' in value || 'containedScroll' in value
}

export function useBreadcrumbs(): Crumb[] {
  const matches = useMatches()
  const location = useLocation()

  return matches.flatMap((match) => {
    if (!isRouteHandle(match.handle) || !match.handle.crumb) return []

    const crumb = match.handle.crumb

    return typeof crumb === 'function' ? crumb(location.pathname) : crumb
  })
}

export function useFullBleed(): boolean {
  const matches = useMatches()

  return matches.some(
    (match) => isRouteHandle(match.handle) && match.handle.fullBleed === true
  )
}

export function useContainedScroll(): boolean {
  const matches = useMatches()

  return matches.some(
    (match) =>
      isRouteHandle(match.handle) && match.handle.containedScroll === true
  )
}
